// Window type options
export const WINDOW_TYPES = [
  { value: 'flat_window', label: 'Flat Window' },
  { value: 'angled_bay', label: 'Angled Bay' },
  { value: 'corner_bay', label: 'Corner Bay' },
];

export const SHUTTER_STYLES = [
  { value: 'full_height', label: 'Full Height' },
  { value: 'tier_on_tier', label: 'Tier on Tier' },
  { value: 'cafe_style', label: 'Café Style' },
];

// Materials with retail + cost pricing (per sqm)
// costPerSqm is INTERNAL ONLY — never sent to customers
export const MATERIALS = [
  {
    id: 'budget',
    name: 'Budget',
    description: 'Quality shutters - 10 year warranty',
    pricePerSqm: 230,
    upfrontPricePerSqm: 207,
    costPerSqm: 95.99,
    costIncVat: true,
    leadTime: '10-12 weeks',
    bayWindowPremium: 20,
    indicator: '£',
  },
  {
    id: 'polymer',
    name: 'Polymer',
    description: 'Water resistant - 10 year warranty',
    pricePerSqm: 300,
    upfrontPricePerSqm: 270,
    costPerSqm: 111.60,
    costIncVat: true,
    leadTime: '10-12 weeks',
    bayWindowPremium: 20,
    indicator: '££',
  },
  {
    id: 'paulownia',
    name: 'Paulownia+',
    description: 'Lightweight hardwood shutters encased in a hard wearing polymer casing - 10 year warranty',
    pricePerSqm: 300,
    upfrontPricePerSqm: 270,
    costPerSqm: 108,
    costIncVat: true,
    leadTime: '10-12 weeks',
    bayWindowPremium: 20,
    indicator: '£££',
    recommended: true,
  },
  {
    id: 'basswood',
    name: 'Basswood',
    description: 'Smooth grain, harder impact resistance & smoother finish - 10 year warranty',
    pricePerSqm: 350,
    upfrontPricePerSqm: 315,
    costPerSqm: 144,
    costIncVat: true,
    leadTime: '10-12 weeks',
    bayWindowPremium: 20,
    indicator: '££££',
  },
  {
    id: 'uk_basswood',
    name: 'UK Made Basswood',
    description: 'Premium UK manufactured basswood - 4-5 week lead time - 10 year warranty',
    pricePerSqm: 405,
    upfrontPricePerSqm: 364.50,
    costPerSqm: 226.08,
    costIncVat: false,
    costExVat: 188.40,
    leadTime: '4-5 weeks',
    bayWindowPremium: 20,
    indicator: '£££££',
  },
  {
    id: 'aluminium',
    name: 'Aluminium',
    description: 'External & security - 10 year warranty',
    pricePerSqm: 420,
    upfrontPricePerSqm: 378,
    costPerSqm: null,
    costIncVat: true,
    leadTime: '10-12 weeks',
    bayWindowPremium: 20,
    indicator: '£££££',
  }
];

export const LOUVRE_SIZES = [
  { value: '63mm', label: '63mm' },
  { value: '76mm', label: '76mm' },
  { value: '89mm', label: '89mm' },
  { value: '114mm', label: '114mm' },
];

export const CONTROL_TYPES = [
  { value: 'central_tilt_rod', label: 'Central Tilt Rod' },
  { value: 'hidden_tilt_rod', label: 'Hidden Tilt Rod' },
  { value: 'remote', label: 'Remote Control' },
];

export const STILES_OPTIONS = [
  { value: 'beaded', label: 'Beaded' },
  { value: 'plain', label: 'Plain' },
];

export const MOUNT_TYPES = [
  { value: 'inside', label: 'Inside Mount' },
  { value: 'outside', label: 'Outside Mount' },
  { value: 'ceiling', label: 'Ceiling Mount' },
];

export const FRAME_TYPES = [
  { value: 'L_frame', label: 'L-Frame' },
  { value: 'Z_frame', label: 'Z-Frame' },
  { value: 'deco_frame', label: 'Deco Frame' },
  { value: 'no_frame', label: 'No Frame' },
];

export const PROPERTY_TYPES = [
  { value: 'house', label: 'House' },
  { value: 'flat', label: 'Flat' },
  { value: 'bungalow', label: 'Bungalow' },
  { value: 'commercial', label: 'Commercial' },
];

export const INITIAL_SURVEY_FORM = {
  customer_name: '',
  customer_email: '',
  customer_phone: '',
  customer_address: '',
  customer_postcode: '',
  survey_date: '',
  surveyor_name: '',
  property_type: 'house',
  property_notes: '',
  general_notes: '',
  access_notes: '',
  installation_notes: '',
  material: 'paulownia',
  hinge_colour: 'White',
  louvre_size: '76mm',
  colour: 'White',
  control_type: 'hidden_tilt_rod',
  stiles: 'beaded',
  customer_notes: '',
  openings: [],
  include_blinds: false,
  blinds: [],
  vat_rate: 20,
  // Which materials to show customer on the quote (surveyor selects)
  selected_quote_materials: ['paulownia'],
};

export const INITIAL_OPENING = {
  room_location: '',
  opening_reference: '',
  window_type: 'flat_window',
  material: 'paulownia',
  width: '',
  height: '',
  layout: '',
  midrail: '',
  split_height: '',
  bay_posts: [],
  t_posts: [],
  shutter_style: 'full_height',
  louvre_size: '76mm',
  colour: 'White',
  control_type: 'hidden_tilt_rod',
  stiles: 'beaded',
  mount_type: 'inside',
  frame_type: 'L_frame',
  has_obstructions: false,
  notes: '',
};
